require('./css/mobile.css')
require('./css/mobile-portrait.css')
require('./css/mobile-landscape.css')
require('./css/steps-list/mobile.css')
require('./css/collections-list/mobile.css')
require('./css/steps-list/steps-list-mobile-portrait.css')
require('./css/steps-list/steps-list-mobile-landscape.css')
require('./css/collections-list/collections-list-mobile-portrait.css')
require('./css/collections-list/collections-list-mobile-landscape.css')
require('./css/steps-list/steps-list-desktop.css')
require('./css/collections-list/collections-list-desktop.css')
require('./css/desktop.css')
require('./css/kiosk.css')
require('./css/spatial-viewer.css')

import storyboard from './js/storyboard'
import dom from './js/dom'
import viewer from './js/viewer'
import collection from './js/collection'
import mobile from './js/mobile'
import tenantService from './js/tenantService'

let tenant = 'haltadefinizione'
tenantService.getTenantName().then((tenantName) => (tenant = tenantName))

if (isMetaQuestBrowser() || isVisionProBrowser()) {
  document.getElementById('toolbarButtons').classList.add('spatial-component')
  document.getElementById('toolBar').classList.add('spatial-component')
  document.querySelectorAll('.toolbar-component').forEach(function (element) {
    element.classList.add('spatial-component')
  })
}

function sendToParent(event) {
  try {
    parent.dispatchEvent(event)
  } catch (corsNotAllowed) {}
}

function disableContextMenu() {
  document.addEventListener(
    'contextmenu',
    function (e) {
      e.preventDefault()
    },
    false,
  )
}

function isMetaQuestBrowser() {
  const userAgent = navigator.userAgent
  return userAgent.includes('OculusBrowser') && userAgent.includes('Quest')
}

function isVisionProBrowser() {
  //return true
  if (
    navigator &&
    navigator.userAgent.includes('Macintosh') &&
    navigator.maxTouchPoints >= 5
  ) {
    return true
  }
  return false
}

window.addEventListener('orientationchange', () => {}, false)
window.addEventListener('resize', () => {
  mobile.fixSizeOnMobileDevices()
})

let params = location.href.split('?')[1].split('&')
let data = {}

for (let x in params) {
  data[params[x].split('=')[0]] = params[x].split('=')[1]
}

window.addEventListener('load', () => {
  disableContextMenu()

  mobile.fixSizeOnMobileDevices()
  let navigatorWidth
  let navigatorHeight

  if (data.onPremises) {
    navigatorWidth = '287px'
    navigatorHeight = '279px'
  }

  if (data.storyID) {
    dom.init(storyboard, data.onPremises, tenant)
    document.body.style.height = window.innerHeight.toString() + 'px'
    document.body.style.width = window.innerWidth.toString() + 'px'
    storyboard.DOM.changeStory.style.display = 'none'
    storyboard.DOM.changeStory.style.pointerEvents = 'none'

    if (data.startWithChapters === '1') {
      storyboard.DOM.stepListContainer.style.opacity = '1'
      storyboard.DOM.stepListContainer.classList.remove('hidden')
    }

    viewer.init(data.storyID, storyboard, navigatorWidth, navigatorHeight)
    const events = ['mousemove', 'mousedown', 'touchmove']
    events.forEach((event) => {
      document.addEventListener(event, () => {
        sendToParent(new Event('user-interacted'))
      })
    })
  } else if (data.collectionID) {
    collection.initDOM(storyboard)
    collection.init(
      data.collectionID,
      storyboard,
      navigatorWidth,
      navigatorHeight,
      data.onPremises,
    )
  } else {
    console.warn('Warning! Please, provide a storyboard ID as url param.')
  }
})
